var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoggerList',{attrs:{"logger_type":"flow","title":"Sone målinger","icon_marker_letter":"F"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }